module.exports = __webpack_public_path__ + "img/432c670.png";